import PropTypes from 'prop-types'

// Help copy for the conjoint head. Ported verbatim from the `val` attributes of
// the cj-help-* links in _conjoint_question.erb / _conjoint_deep_question.erb.
// Segmentation adds a persona paragraph that Express omits.

const ARTICLE_URL = 'https://aytm.zendesk.com/hc/en-us/articles/11267587727757-Analyzing-a-Conjoint-test'

const ArticleLink = () => (
  <>
    To learn more about analyzing a conjoint test, visit this article:{' '}
    <a href={ARTICLE_URL} target="_blank" rel="noreferrer">
      Analyzing a Conjoint test
    </a>
  </>
)

const ImportanceParagraph = () => (
  <>
    Importance values for each attribute are calculated as shares of ranges of utility scores. The higher importance,
    the higher impact a decision on the attribute has on the package&apos;s market share.
  </>
)

const PersonaParagraph = ({ inSimulator }) => (
  <>
    For Conjoint segmentation, the system will generate up to seven personas when enough responses have been collected
    using the Gaussian Mixture Clustering model. Click on a persona to view results for the specific segment
    {inSimulator ? ' in the market simulator' : ''}.
  </>
)

const LiteHelp = ({ questionType }) => (
  <>
    <p>
      This is the lightweight attribute view of the conjoint results. Click <b>Simulator View</b> above to load the full
      dataset &mdash; this enables the market simulator and Preference Likelihood mode.
    </p>
    <br />
    <p>
      <ImportanceParagraph />
    </p>
    <br />
    {'cjd' === questionType ? (
      <>
        <p>
          <PersonaParagraph inSimulator={false} />
        </p>
        <br />
      </>
    ) : null}
    <p>
      <ArticleLink />
    </p>
  </>
)

const FullHelp = ({ questionType }) => (
  <>
    <p>Conjoint results can be analyzed using the market simulator:</p>
    <br />
    <p>
      <b>Preference Likelihood mode</b> assumes a state of the market when two packages exist: an average one, and the
      chosen one. With such settings it is possible to see how market share of the chosen package change with a change
      of the attributes.
    </p>
    <br />
    <p>
      <b>Utility scores mode</b> uses raw Logit coefficients of the chosen package. In this setting an average package
      gets a score of 0.
    </p>
    <br />
    <p>
      <ImportanceParagraph />
    </p>
    <br />
    {'cjd' === questionType ? (
      <>
        <p>
          <PersonaParagraph inSimulator />
        </p>
        <br />
      </>
    ) : null}
    <p>
      Use <b>Attribute View</b> above to switch to the importance chart.
    </p>
    <br />
    <p>
      <ArticleLink />
    </p>
  </>
)

const ChartHelp = () => (
  <p>
    Use <b>Simulator View</b> above to switch to the interactive Conjoint simulator.
  </p>
)

const HeadHelp = ({ questionType, mode }) => {
  if ('lite' === mode) return <LiteHelp questionType={questionType} />
  if ('chart' === mode) return <ChartHelp />
  return <FullHelp questionType={questionType} />
}

PersonaParagraph.propTypes = { inSimulator: PropTypes.bool }
LiteHelp.propTypes = { questionType: PropTypes.string }
FullHelp.propTypes = { questionType: PropTypes.string }

HeadHelp.propTypes = {
  questionType: PropTypes.oneOf(['cjc', 'cjd']),
  mode: PropTypes.oneOf(['lite', 'full', 'chart'])
}

HeadHelp.displayName = 'ConjointHeadHelp'

export default HeadHelp
